import {
    DestroyRef,
    Injectable,
    NgZone,
    PLATFORM_ID,
    inject,
    signal,
    afterNextRender,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ViewportService {
    readonly #destroyRef = inject(DestroyRef);
    readonly #zone = inject(NgZone);
    readonly #platformId = inject(PLATFORM_ID);
    readonly #doc = inject(DOCUMENT);

    readonly width = signal(0);
    readonly height = signal(0);

    constructor() {
        if (!isPlatformBrowser(this.#platformId)) return;

        const read = () => {
            const vv = (window as any).visualViewport;
            const w =
                vv?.width ??
                window.innerWidth ??
                this.#doc.documentElement.clientWidth ??
                0;
            const h =
                vv?.height ??
                window.innerHeight ??
                this.#doc.documentElement.clientHeight ??
                0;
            this.width.set(Math.round(w));
            this.height.set(Math.round(h));
        };

        afterNextRender(read);

        let scheduled = false;
        const onResize = () => {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(() => {
                scheduled = false;
                read();
            });
        };

        this.#zone.runOutsideAngular(() => {
            window.addEventListener('resize', onResize, { passive: true });
            (window as any).visualViewport?.addEventListener(
                'resize',
                onResize,
                { passive: true },
            );
        });

        this.#destroyRef.onDestroy(() => {
            window.removeEventListener('resize', onResize);
            (window as any).visualViewport?.removeEventListener(
                'resize',
                onResize,
            );
        });
    }
}
